<script setup>

</script>

<template>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

        <sonicu-header>
            Create New Address
        </sonicu-header>

        <div class="mt-5 md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <span class="text-lg font-medium leading-6 text-gray-900">Nickname for Address</span>
                    <p class="mt-1 text-sm leading-5 text-gray-600">
                        Give your address a nickname to help you identify it.
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-4 gap-x-6 gap-y-8">

                            <div class="col-span-4 sm:col-span-4">
                                <label for="nickname" class="block text-sm font-medium leading-6 text-gray-900">
                                    Nickname
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.nickname" type="text" name="nickname" id="nickname" placeholder="Infinity Design Main" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <span class="text-lg font-medium leading-6 text-gray-900">Zones</span>
                    <p class="mt-1 text-sm leading-5 text-gray-600">
                        Select the zones to associate with this address.
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-4 gap-x-6 gap-y-8">

                            <div class="col-span-4 sm:col-span-4">
                                <label for="zone" class="block text-sm font-medium leading-6 text-gray-900">
                                    Zones
                                </label>
                                <div class="mt-2">
                                    <select2-group id="zone_ids_group"
                                                   name="zones[]"
                                                   :options="this.zones"
                                                   v-model="form.zones"
                                                   placeholder="-- No Zones Selected --"
                                                   :multiple=true
                                    ></select2-group>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <span class="text-lg font-medium leading-6 text-gray-900">Recipient Details</span>
                    <p class="mt-1 text-sm leading-5 text-gray-600">
                        Provide the recipient's details and specify the person or department to direct the delivery or communication to, along with their contact email if necessary.
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-4 gap-x-6 gap-y-8">

                            <div class="col-span-4 sm:col-span-4">
                                <label for="name" class="block text-sm font-medium leading-6 text-gray-900">
                                    Name
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.name" type="text" name="name" id="name" placeholder="John Doe" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-2">
                                <label for="attention" class="block text-sm font-medium leading-6 text-gray-900">
                                    Attention
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.attention" type="text" name="attention" id="attention" placeholder="Customer Support" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-2">
                                <label for="attention_email" class="block text-sm font-medium leading-6 text-gray-900">
                                    Attention Email
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.attention_email" type="email" name="attention_email" id="attention_email" placeholder="john.doe@example.com" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <span class="text-lg font-medium leading-6 text-gray-900">Address Details</span>
                    <p class="mt-1 text-sm leading-5 text-gray-600">
                        Provide the address details
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow overflow-hidden sm:rounded-md">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-4 gap-x-6 gap-y-8">

                            <div class="col-span-4 sm:col-span-4">
                                <label for="line1" class="block text-sm font-medium leading-6 text-gray-900">
                                    Address Line 1
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.line1" type="text" name="line1" id="line1" placeholder="456 Corporate Blvd" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <label for="line2" class="block text-sm font-medium leading-6 text-gray-900">
                                    Address Line 2 <span class="ml-3 text-sm text-gray-400">Optional</span>
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.line2" type="text" name="line2" id="line2" placeholder="Suite 300" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <label for="line3" class="block text-sm font-medium leading-6 text-gray-900">
                                    Address Line 3 <span class="ml-3 text-sm text-gray-400">Optional</span>
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.line3" type="text" name="line3" id="line3" placeholder="Business Park East" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-2">
                                <label for="city" class="block text-sm font-medium leading-6 text-gray-900">
                                    City
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.city" type="text" name="city" id="city" placeholder="Greenfield" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-1">
                                <label for="state" class="block text-sm font-medium leading-6 text-gray-900">
                                    State
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.state" type="text" name="state" id="state" placeholder="IN" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-4 sm:col-span-1">
                                <label for="zip" class="block text-sm font-medium leading-6 text-gray-900">
                                    Zip
                                </label>
                                <div class="mt-2">
                                    <input v-model="form.zip" type="text" name="zip" id="zip" placeholder="46140" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end gap-5">
            <button @click="cancelEdit" class="bg-gray-100 hover:bg-gray-200 focus:ring-gray-200 focus:bg-gray-200 active:bg-gray-300 max-w-48 w-1/2 mt-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-900 shadow-sm focus:outline-none">
                Cancel
            </button>

            <button @click="updateAddress" class="bg-blue-600 hover:bg-blue-500 focus:ring-blue-200 focus:bg-blue-500 active:bg-blue-600 max-w-48 w-1/2 mt-4 py-2 border border-transparent text-sm font-medium rounded-md text-white shadow-sm focus:outline-none">
                Save Changes
            </button>

            <button @click="deleteAddress" class="bg-red-600 hover:bg-red-500 focus:ring-red-200 focus:bg-red-500 active:bg-red-600 max-w-48 w-1/2 mt-4 py-2 border border-transparent text-sm font-medium rounded-md text-white shadow-sm focus:outline-none">
                Delete
            </button>
        </div>

    </div>

</template>
<script>
import SonicuHeader from "../elements/SonicuHeader.vue";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from 'axios';

export default {
    components: {SonicuHeader},
    mixins: [SonicuCoreMixin],
    props: {
        company: {
            type: Object,
            required: true
        },
        address: {
            type: Object,
            required: true
        },
        zones: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                nickname: this.address.nickname,
                name: this.address.name,
                attention: this.address.attention,
                attention_email: this.address.attention_email,
                line1: this.address.line1,
                line2: this.address.line2,
                line3: this.address.line3,
                city: this.address.city,
                state: this.address.state,
                zip: this.address.zip,
                zones: this.address.zones.map(zone => zone.ID),
            }
        }
    },
    methods: {
        updateAddress() {
            axios.patch(this.company.buildCompanyRoute('addresses/' + this.address.id), this.form)
                .then(response => {
                    window.location.href = this.company.buildCompanyRoute('addresses');
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteAddress() {
            axios.delete(this.company.buildCompanyRoute('addresses/' + this.address.id))
                .then(response => {
                    window.location.href = this.company.buildCompanyRoute('addresses');
                })
                .catch(error => {
                    console.log(error);
                });
        },
        cancelEdit() {
            window.location.href = this.company.buildCompanyRoute('addresses');
        }
    }
}
</script>
